import React from 'react';
import { useLocation } from 'react-router-dom';
import SimpleTabs from '../../../components/tabs/simpleTabs';
import MailchimpPanelIcon from '../../../assets/icons/mailchimp-logo.svg';
import { EmailProvidersTabLinks } from '../../../components/enums/tabEnums';

const EmailProviders = () => {
  const location = useLocation();
  const activePanel = EmailProvidersTabLinks[location.pathname.split('/').pop() as keyof typeof EmailProvidersTabLinks] || 0;

  return (
    <div className="h-full rounded-lg border border-dark bg-white px-6 py-4">
      <SimpleTabs
        currentTab={activePanel}
        tabs={[
          {
            tabLabel: 'Mailchimp',
            href: 'mailchimp',
            identifierName: 'mailchimp',
            icon: MailchimpPanelIcon,
          },
        ]}
      />
    </div>
  );
};

export default EmailProviders;
